import React, { useState } from "react";
import { ArrowLeftRight } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import IconAction from "@/components/IconAction";

const CFG = {
  "to-cabinet": {
    url: (id) => `/expenses/lines/${id}/to-cabinet`,
    label: "Basculer cette ligne vers les dépenses internes du cabinet",
    confirm: "Basculer cette ligne de votre NDF vers les dépenses internes du cabinet ? Le justificatif sera déplacé dans le dossier Drive des dépenses internes.",
    done: "Ligne basculée vers les dépenses internes",
  },
  "to-ndf": {
    url: (id) => `/cabinet-expenses/lines/${id}/to-ndf`,
    label: "Basculer cette dépense vers votre note de frais (NDF) du mois",
    confirm: "Basculer cette dépense interne vers votre NDF du mois ? Le justificatif sera déplacé dans votre dossier Drive « Notes de frais ».",
    done: "Dépense basculée vers votre NDF",
  },
};

// Iter-314 — CEO-only switch of a line between his own NDF and the cabinet internal expenses.
export const SwitchLineButton = ({ direction, lineId, disabledReason, onDone, size }) => {
  const [busy, setBusy] = useState(false);
  const cfg = CFG[direction];
  const run = async () => {
    if (!window.confirm(cfg.confirm)) return;
    setBusy(true);
    try {
      const r = await api.post(cfg.url(lineId));
      toast.success(cfg.done);
      if (r.data?.drive_warning) toast.warning(r.data.drive_warning, { duration: 9000 });
      onDone && onDone(r.data);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Bascule impossible");
    } finally {
      setBusy(false);
    }
  };
  return (
    <IconAction icon={ArrowLeftRight} tone="blueSoft" size={size} loading={busy}
      disabled={!!disabledReason} label={disabledReason || cfg.label}
      testid={`switch-${direction}-${lineId}`} onClick={run} />
  );
};
